 export const containerStyle = () => {
    const _style =
      {
        maxWidth: "100%",
        margin: "0px 0px",
        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1)",
        backgroundColor: "lightGrey"
      };
    return _style;
  };
  export const rowStyle = () => {
    const _style =
      {
            textDecoration: "",
            color: "red",
            backgroundColor: "#f3f2f1"
      };
    return _style;
  };
  export const lineStyle = () => {
    const _style =
       {
            height : "1px",
            backgroundColor: "#0178d4"
            
        };
    return _style;
  };

  export const columnStyle = () => {
    const _style =
      {
            textDecoration: "",
            color: "red",
            backgroundColor: "#f3f2f1"
      };
    return _style;
  };
